<template>
    <div v-if="product.info.operatedBy && product.info.supplierCode === 'jonview'" class="order-info-base-info">
        <span class="order-info-base-info__icon ml-6">
            <v-icon start size="x-small">mdi-account-outline</v-icon>
            <span class="text-body-2">{{ $t('operated_by') }}</span>
        </span>
        <span class="order-info-base-info__text">
            {{ product.info.operatedBy }}
        </span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TransferOperatedByLabel extends Vue {
        @Prop({required: true, type: Object}) product
    }

    export default TransferOperatedByLabel
</script>
